import React from 'react';
import { Row, Col, Card, Select, DatePicker, Button, message, Modal } from 'antd';
import { Formik, Form, ErrorMessage } from 'formik';
import Item from '../../../components/Form/Item';
import { Link } from 'react-router-dom';
import { verificationSchema } from '../../Register/schema';
import axios from '../../../util/Api';

const { Option } = Select;

const VerificationForm = ({ passport }) => {

  const showNotificationModal = (content) => {
    Modal.success({
      title: "Verifikasi personel telah berhasil dilakukan",
      content: (
        <div>
          Verifikasi personel telah berhasil dilakukan. Silakan kirimkan notifikasi ke {passport.vendor.name} melalui Whatsapp.
        </div>
      ),
      okText: "Kirimkan Notifikasi",
      onOk() {
        //redirect to wa.me, then reload the detail page
        window.open(content.url, '_blank');
        // if (window.reloadDetail) {
        //   window.reloadDetail();
        // }
      }
    });
  }

  return (
    <Formik
      initialValues={{
        induction_status: undefined,
        approval: undefined
      }}
      validationSchema={verificationSchema}
      onSubmit={values => {
        const url = `/passport/verification?id=${passport.id}`;
        axios.post(url, { ...values }).then(resp => {
          if (resp.data.success) {
            showNotificationModal(resp.data.whatsapp);
            if (window.reloadDetail) {
              window.reloadDetail();
            }
          }
        }).catch(err => {
          message.error("Gagal melakukan verifikasi");
        });
      }}
    >
      {(formik)=>{
        return (
          <Form>
            <Card className="gx-card" title="Verifikasi Data QHSE">
              <Row>
                <Col span={12}>
                  <Item inline={false} name="Hasil Induksi" required>
                    <Select
                      name="induction_status"
                      defaultValue={formik.values.induction_status}
                      onChange={(value) => formik.setFieldValue("induction_status", value)}
                      placeholder="Pilih status"
                    >
                      <Option value="true">Passed</Option>
                      <Option value="false">Not Passed</Option>
                    </Select>
                    <ErrorMessage component="div" name="induction_status" className="gx-mt-2 gx-text-red" />
                  </Item>
                </Col>
                <Col span={12}>
                  <Item inline={false} name="Approval PM" required>
                    <Select
                      name="approval"
                      defaultValue={formik.values.approval}
                      onChange={(value) => formik.setFieldValue("approval", value)}
                      placeholder="Pilih persetujuan PM"
                    >
                      <Option value="true">Setuju</Option>
                      <Option value="false">Tolak</Option>
                    </Select>
                    <ErrorMessage component="div" name="approval" className="gx-mt-2 gx-text-red" />
                  </Item>
                </Col>
              </Row>

              <div className="gx-mt-2 gx-text-right">
                <Link to="/passport" className="ant-btn ant-btn-secondary gx-mb-0">
                  Batal
                </Link>
                <Button type="primary" htmlType="submit" className="gx-mb-0" loading={formik.isSubmitting}>
                  Simpan
                </Button>
              </div>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
}

export default VerificationForm;